import siteConfiguration from "@/config";

const messages = {
  en: {
    shared: {
      buttons: {
        save_changes: "Save Changes",
        save: "Save",
        change: "Change",
        next: "Next",
        prev: "Previous",
        cancel: "Cancel",
        saving: "Saving Data..",
        submit: "Submit",
        upload_file: "Upload File",
        updating_data: "Updating data..",
        confirm: "Confirm",
        processing: "Processing...",
        sending: "Sending...",
        deposit: "Deposit",
        back_home: "Home",
        creating_account: "Creating account...",
        download_pdf: "Donwload PDF"
      },
      messages: {
        creating_mt4_account: "Creating MT4 account...",
        please_wait: "Please wait...",
        ok: {
          title: "OK",
          text: "Your changes have been saved them"
        },
        error: {
          title: "ERROR",
          text: "There was an error processing your request"
        }
      }
    },
    login: {
      login_to: "<strong>Login</strong> to ",
      access_your_account: "Access your <strong>Account</strong>",
      user_name: "User Name (E-mail)",
      password: "Password",
      login: "LOGIN",
      forgot_your_password: "Forgot your password?",
      forgot_your_password_desc: "Enter your e-mail address",
      dont_have_an_account: "Don't have an Account?",
      welcome_to: "<strong>Welcome</strong> to <br/>",
      welcome_to_description:
        "EN Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi porttitor Hawk International Consultants hendrerit odio. Vivamus fringilla sollicitudin fringilla. Aenean semper enim magna. Nullam vel euismod justo. Suspendisse potenti. Proin bibendum sapien nec odio convallis,",
      get_started: "GET STARTED"
    },
    profile: {
      title: "My Profile",
      update_profile: "Update Profile",
      documents: "Documents",
      change_password: "Change Password",
      change_password_now: "Cambiar Contraseña Now",
      personal_details: "Personal Details",
      access_your_account: "Access your <strong>Account</strong>",
      first_name: "Firt Name",
      last_name: "Last Name",
      email: "E-mail",
      phone: "Phone",
      id_number: "ID Number",
      address: "Address",
      street: "Street",
      city: "City",
      state: "State",
      postcode: "Postcode",
      country: "Country",
      date_of_birth: "Date of Birth",
      more_information: "More Information",
      trading_frequency: "Trading frequency",
      financial_instruments: "Financial instruments",
      experience: "Experience",
      risk_tolerance: "Risk Tolerance:",
      education: "Education",
      annual_revenue: "Annual Revenue",
      deposit_funds: "Deposit Funds",
      total_deposit_funds: "Total Deposit Funds",
      messages: {
        save_ok: "Your profile has been updated",
        change_password_ok: "Your password has been changed"
      },
      password_validators: {
        letter: "At least one letter",
        capital: "At least one capital letter",
        number: "At least one number",
        length: "Be at least 8 characters",
        special: "No special characters"
      }
    },
    register: {
      open_demo_account: "Open Demo Account",
      open_live_account: "Open Live Account",
      personal_details: "Personal Details",
      first_name: "First Name",
      last_name: "Last Name",
      email: "E-mail",
      phone: "Phone",
      address: "Address",
      date_of_birth: "Date of Birth",
      city: "City",
      state: "State",
      zip_code: "Postcode",
      country: "Country",
      accept_terms:
        "NOTE: By creating an account you are accepting our <a href='" +
        siteConfiguration.TERMS_AND_CONDITIONS_URL +
        "' target='_blank'>terms and conditions</a>",
      create_account: "Create Account",
      messages: {
        account_created_ok: "Thank you! Your account has been created"
      }
    },
    navbar: {
      need_help: "Need help",
      welcome: "Welcome",
      user_profile: "User Profile",
      logout: "Logout",
      dashboard: "Dashboard",
      account: "Account",
      create_new_account: "Create new Account",
      news: "News",
      blog: "Blog",
      documentation: "Documentation",
      withdrawal: "Withdrawal",
      downloadmt4: "Download MT4",
      webtrader: "Webtrader",
      deposit_funds: "Deposit Funds",
      personal_information: "Personal Information",
      languages: [
        {
          code: "en",
          name: "English"
        },
        {
          code: "es",
          name: "Spanish"
        }
      ]
    },
    withdrawal: {
      title: "Withdrawal",
      subtitle:
        "From here you can request a withdrawal from your account balance.",
      please_select:
        "Please select your withdrawal method (bank transfer or credit / debit):",
      bank_details: "Bank Details",
      personal_details: "Personal Details",
      credit_card_details: "Credit/Debit Card Details",
      bank_transfer: "Bank Transfer",
      credit_debit: "Credit / Debit Card",
      first_name: "First Name",
      last_name: "Last Name",
      address: "Address",
      phone: "Phone",
      email: "Email",
      mt4_account_number: "MT4 Account Number",
      bank_account_number: "Bank Account Number",
      bank_name: "Bank name",
      bank_address: "Bank Address",
      swift_code: "Swift Code / BIC",
      iban: "IBAN",
      amount: "Amount",
      last_four_digits: "Last 4 digits of credit card",
      deposit_funds: "Deposit Funds",
      total_deposit_funds: "Total Deposit Funds",
      warnings: {
        not_available_for_demo_accounts:
          "Withdrawals are not available for Demo accounts, please choose a Live Account to place the withdrawal request.",
        no_enough_funds:
          "Please note that you have no avaliable funds for this transaction type.",
        four_digits_required: "Please, this field is required",
        four_digits_wrong_format: "This field must be a number"
      }
    },
    summary: {
      account_summary: "Account Summary"
    },
    dashboard: {
      account_information: "Select Account",
      account_description: "Account Description",
      status: "status",
      status_list: ["Active", "Working"],
      account_type: "Account Type",
      leverage: "Leverage",
      personal_details: "Personal Details",
      news: "News",
      blog: "Blog",
      first_name: "First Name",
      last_name: "Last Name",
      full_name: "Full Name",
      phone: "Phone Number",
      email: "E-mail",
      address: "Address",
      view_all: "View All",
      show_more: "Show More",
      deposit_funds: "Deposit Funds",
      make_deposit: "Make Deposit",
      edit: "Editar Profile",
      change_password: "Change Password",
      account_value:
        "Account Value (" + siteConfiguration.DEFAULT_CURRENCY + ")"
    },
    total_balance: {
      account: "Account"
    },
    support: {
      title: "Support Ticket",
      subtitle: "From here you can create a Support Ticket",
      ticket_sent: "Your Ticket has been sent."
    },
    deposit: {
      title: "Deposit Funds",
      subtitle:
        "For deposit in your account please select one of the following methods:",
      create_live_account_now: "Create Live account now",
      all_transitions_are_safe_and_secure:
        "All transitions are safe and secure",
      select_payment_method: "Select a payment method",
      payment_method: "Payment method",
      deposit_amount: "Deposit Amount",
      summary_and_payment: "Summary",
      select_amount_to_deposit:
        "Input the quantity in dollars that you want to deposit in your account.",
      amount: "Amount",
      currency: "Currency",
      loading_payment_methods: "Loading Payment Methods",
      mt4_account: "MT4 Account",
      results: {
        approved: {
          status: "APPROVED",
          message: "Your payment has been approved"
        },
        failed: {
          status: "FAILED",
          message: "There was an error processing your payment"
        },
        canceled: {
          status: "CANCELED",
          message: "Your payment has been canceled by user"
        },
        declined: {
          status: "DECLINED",
          message: "Your payment has been declined"
        }
      },
      warnings: {
        you_should_have_a_live_account:
          "You should have a Live account created so as to be able to make a deposit.",
        incomplete_profile:
          '<strong>Warning:</strong> You must fill out all the fields from your profile or by <a href="/client/profile">clicking here</a>',
        select_live_account:
          "<strong>Warning</strong> You must select a Live account in order to be able to make a transfer"
      }
    }
  },
  es: {
    shared: {
      buttons: {
        save_changes: "Guardar Cambios",
        save: "Guardar",
        change: "Cambiar",
        next: "Siguiente",
        prev: "Anterior",
        cancel: "Cancelar",
        saving: "Guardando...",
        submit: "Enviar",
        upload_file: "Subir Archivo",
        updating_data: "Actualizando...",
        confirm: "Confirmar",
        processing: "Procesando...",
        sending: "Enviando...",
        deposit: "Depositar",
        back_home: "Volver",
        creating_account: "Creando cuenta...",
        download_pdf: "Descargar PDF"
      },
      messages: {
        creating_mt4_account: "Creando su cuenta MT4...",
        please_wait: "Por favor, espere...",
        ok: {
          title: "OK",
          text: "Se han guardado los cambios"
        },
        error: {
          title: "ERROR",
          text: "Hubo un error tratando de guardar los cambios"
        }
      }
    },
    profile: {
      title: "Mi Perfil",
      documents: "Documentos",
      change_password: "Cambiar Contraseña",
      change_password_now: "Cambiar Contraseña Ahora",
      personal_details: "Datos Personales",
      access_your_account: "Access your <strong>Account</strong>",
      first_name: "Nombre",
      last_name: "Apellido",
      email: "E-mail",
      phone: "Teléfono",
      id_number: "Documento de Identidad",
      address: "Domicilio",
      street: "Calle",
      city: "Ciudad",
      state: "Estado",
      postcode: "Código Postal",
      country: "País",
      date_of_birth: "Fecha de Nacimiento",
      more_information: "Información Adicional",
      trading_frequency: "Frecuencia de Negociación",
      financial_instruments: "Intrumentos Financieros",
      experience: "Experiencia",
      risk_tolerance: "Tolerancia al Riego:",
      education: "Educación",
      annual_revenue: "Ingresos Anuales",
      update_profile: "Actualizar Perfil",
      deposit_funds: "Depositar Fondos",
      total_deposit_funds: "Total Depositado",
      messages: {
        save_ok: "Su datos han sido actualizados",
        change_password_ok: "Su contraseña ha sido modificada"
      },
      password_validators: {
        letter: "Al menos una letra",
        capital: "Al menos una letra en mayúsculas",
        number: "Al menos un número",
        length: "Debe contar con una longitud de entre 8 y 10 caracteres",
        special: "No utilizar caracteres especiales"
      }
    },
    register: {
      open_demo_account: "Abrir Cuenta Demo",
      open_live_account: "Abrir Cuenta Real",
      personal_details: "Datos Personales",
      first_name: "Nombre",
      last_name: "Apellido",
      email: "E-mail",
      phone: "Teléfono",
      address: "Domicilio",
      date_of_birth: "Fecha de Nacimiento",
      city: "Ciudad",
      state: "Estado",
      zip_code: "Código Postal",
      country: "País",
      accept_terms:
        "NOTA: al crear una cuenta está aceptando nuestros <a href='" +
        siteConfiguration.TERMS_AND_CONDITIONS_URL +
        "' target='_blank'>Términos y Condiciones</a>",
      create_account: "Crear Cuenta",
      messages: {
        account_created_ok: "Gracias! Su cuenta ha sido creada."
      }
    },
    login: {
      login_to: "<strong></strong>",
      access_your_account: "Ingresar a la <strong>plataforma</strong>",
      user_name: "Nombre de Usuario (E-mail)",
      password: "Contraseña",
      login: "INGRESAR",
      forgot_your_password: "Olvidó su contraseña?",
      forgot_your_password_desc: "Ingrese su e-mail",
      dont_have_an_account: "No tiene una cuenta?",
      welcome_to: "<strong>Bienvenido</strong> a <br/>",
      welcome_to_description:
        "ES Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi porttitor Hawk International Consultants hendrerit odio. Vivamus fringilla sollicitudin fringilla. Aenean semper enim magna. Nullam vel euismod justo. Suspendisse potenti. Proin bibendum sapien nec odio convallis,",
      get_started: "COMENZAR"
    },
    navbar: {
      need_help: "Necesita ayuda",
      welcome: "Bienvenido",
      user_profile: "Mi Perfil",
      logout: "Salir",
      dashboard: "Dashboard",
      account: "Mi Cuenta",
      create_new_account: "Crear cuenta",
      news: "Novedades",
      blog: "Blog",
      documentation: "Documentación",
      withdrawal: "Retirar Fondos",
      downloadmt4: "Descargar MT4",
      webtrader: "Webtrader",
      deposit_funds: "Depositar Fondos",
      personal_information: "Información Personal",
      languages: [
        {
          code: "en",
          name: "English"
        },
        {
          code: "es",
          name: "Spanish"
        }
      ]
    },
    withdrawal: {
      title: "Retirar Fondos",
      subtitle: "Desde aquí puede solicitar un retiro del saldo de su cuenta.",
      explanation:
        '<p>Documentos requeridos:</p><ul><li>Una copia válida de su documento de identificación.</li><li>Comprobante de residencia.</li><li>Solicitud de retiro firmada. </li></ul><p>Al llenar la solicitud de retiro, por favor preste especial atención a los detalles del pago. Los fondos sólo pueden ser retirados a una cuenta bancaria a su nombre. No realizamos transferencias a cuentas bancarias de terceros.</p><p>Tenga en cuenta que para efectos de KYC (Know-your-customer), 2Mercadoss puede requerir que envíe documentación adicional en casos donde los mencionados documentos se consideran insuficientes.</p><p>Importante: La documentación debe estar completa y ser legible. Si hace falta algún documento o alguno de ellos no es legible, su retiro será rechazado y usted deberá realizar una nueva solicitud. Puede enviar sus documentos al correo electrónico <a href="mailto:' +
        siteConfiguration.COMPLIANCE_EMAIL +
        '">' +
        siteConfiguration.COMPLIANCE_EMAIL +
        "</a> o subirlos a través de su área de cliente.</p><p>Toda solicitud deberá ser aprobada por administración.</p>",
      please_select:
        "Por favor seleccione su método de retiro (Transferencia Bancaria o Tarjeta de Crédito/Débito):",
      bank_details: "Datos Bancarios",
      personal_details: "Datos Personales",
      credit_card_details: "Detalles de la tarjeta de Crédito/Débito",
      bank_transfer: "Transferencia Bancaria",
      credit_debit: "Tarjeta de Crédito/Débito",
      first_name: "Nombre",
      last_name: "Apellido",
      address: "Domicilio",
      phone: "Teléfono",
      email: "E-mail",
      mt4_account_number: "MT4 Account Number",
      bank_account_number: "Número de cuenta bancaria",
      bank_name: "Nombre del Banco",
      bank_address: "Domicilio del Banco",
      swift_code: "Swift Code / BIC",
      iban: "IBAN",
      amount: "Monto",
      last_four_digits: "Últimos 4 digitos de la tarjeta de crédito/débito",
      deposit_funds: "Deposit Funds",
      total_deposit_funds: "Total Deposit Funds",
      warnings: {
        not_available_for_demo_accounts:
          "Los Retiros no están disponibles para cuentas Demo, por favor seleccione una cuenta Real para poder realizarlo.",
        no_enough_funds:
          "No tiene fondos suficientes para realizar esta operación.",
        four_digits_required: "Este campo es requerido",
        four_digits_wrong_format: "Ingrese un número válido"
      }
    },
    summary: {
      account_summary: "Resumen de la Cuenta"
    },
    dashboard: {
      account_information: "Seleccione Cuenta",
      account_description: "Descripción de la Cuenta",
      status: "Estado",
      status_list: ["Activa", "Funcionando"],
      account_type: "Tipo de Cuenta",
      leverage: "Apalancamiento",
      personal_details: "Datos Personales",
      news: "Noticias",
      blog: "Blog",
      full_name: "Nombre",
      first_name: "Nombre",
      last_name: "Apellidos",
      phone: "Teléfono",
      email: "E-mail",
      address: "Domicilio",
      view_all: "Ver Todo",
      show_more: "Ver Más",
      deposit_funds: "Depositar Fondos",
      make_deposit: "Realizar Depósito",
      edit: "Editar Perfil",
      change_password: "Cambiar Contraseña",
      account_value:
        "Valor de la Cuenta (" + siteConfiguration.DEFAULT_CURRENCY + ")"
    },
    total_balance: {
      account: "Cuenta"
    },
    support: {
      title: "Soporte",
      subtitle: "Desde aquí podrá crear un Ticket",
      ticket_sent: "Su ticket ha sido enviado."
    },
    deposit: {
      all_transitions_are_safe_and_secure:
        "Todas las transacciones son seguras y están protegidas",
      title: "Depositar Fondos",
      create_live_account_now: "Crear cuenta Real ahora",
      subtitle:
        "Para efectuar depositos en su cuenta por favor selecciona uno de los siguientes métodos:",
      select_payment_method: "Seleccione un método de pago",
      payment_method: "Método de Pago",
      deposit_amount: "Importe a Depositar",
      summary_and_payment: "Resumen y Pago",
      select_amount_to_deposit:
        "Ingrese la cantidad que desee depositar en su cuenta.",
      amount: "Importe",
      currency: "Moneda",
      mt4_account: "Cuenta MT4",
      loading_payment_methods: "Cargando Métodos de Pago",
      results: {
        approved: {
          status: "APROBADO",
          message: "Su depósito ha sido realizado con éxito"
        },
        failed: {
          status: "ERROR",
          message: "Ha habido un error intentado realizar su deposito"
        },
        canceled: {
          status: "CANCELADO",
          message: "Su transacción ha sido cancelada"
        },
        declined: {
          status: "DECLINADO",
          message: "Su pago ha sido rechazado"
        }
      },
      warnings: {
        you_should_have_a_live_account:
          "<strong>Atención!</strong> Debe tener creada una cuenta Live para poder realizar depósitos.",
        incomplete_profile:
          '<strong>Atención</strong> Debe rellenar todos los campos de la pestaña de información personal o haciendo <a href="/client/profile">clic aquí</a>',
        select_live_account:
          "<strong>Atención</strong> Debe seleccionar una cuenta Real para poder realizar depósitos"
      }
    }
  },
  pt: {
    profile: {
      personal_details: "Personal Details",
      access_your_account: "Access your <strong>Account</strong>",
      first_name: "Firt Name"
    },
    login: {
      login_to: "<strong>Login</strong> para ",
      access_your_account: "Acessar a <strong>plataforma</strong>",
      user_name: "Nome de Usuário (E-mail)",
      password: "Senha",
      login: "ENTRAR",
      forgot_your_password: "Esqueceu sua senha?",
      dont_have_an_account: "Não tem uma conta?",
      welcome_to: "<strong>bem-vindo</strong> a <br/>",
      welcome_to_description:
        " PT Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi porttitor Hawk International Consultants hendrerit odio. Vivamus fringilla sollicitudin fringilla. Aenean semper enim magna. Nullam vel euismod justo. Suspendisse potenti. Proin bibendum sapien nec odio convallis,",
      get_started: "INICIAR"
    },
    navbar: {
      need_help: "Necesita ayuda",
      welcome: "Welcome",
      user_profile: "User Profile",
      logout: "Logout",
      dashboard: "Dashboard",
      account: "Account",
      create_new_account: "Create new Account",
      news: "News",
      blog: "Blog",
      documentation: "Documentación",
      withdrawal: "Retirar Fondos",
      downloadmt4: "Descargar MT4",
      webtrader: "Webtrader",
      deposit_funds: "Depositar Fondos",
      personal_information: "Personal Information",
      languages: [
        {
          code: "en",
          name: "English"
        },
        {
          code: "es",
          name: "Spanish"
        },
        {
          code: "pt",
          name: "Portuguese"
        }
      ]
    },
    withdrawal: {
      title: "Withdrawal",
      subtitle:
        "From here you can request a withdrawal from your account balance.",
      please_select:
        "Please select your withdrawal method (bank transfer or credit / debit):",
      bank_transfer: "Bank Transfer",
      credit_debit: "Credit / Debit Card",
      name: "Name",
      address: "Address",
      phone: "Phone",
      email: "Email",
      mt4_account_number: "MT4 Account Number",
      bank_account_number: "Bank Account Number",
      bank_name: "Bank name",
      bank_address: "Bank Address",
      swift_code: "Swift Code / BIC",
      iban: "IBAN",
      amount: "Amount",
      last_four_digits: "Last 4 digits of credit card",
      deposit_funds: "Deposit Funds",
      total_deposit_funds: "Total Deposit Funds"
    }
  }
};

export default messages;



// WEBPACK FOOTER //
// ./src/lang/index.js